import type { CrmPartnershipStatus } from '@upme/contracts';

export const CRM_PARTNERSHIP_STATUS_LABEL_RU: Record<CrmPartnershipStatus, string> = {
  PARTNER: 'Действующий партнёр',
  NEGOTIATING: 'В переговорах',
  EXTERNAL: 'Внешний каталог',
};

export const CRM_PARTNERSHIP_STATUS_ORDER: readonly CrmPartnershipStatus[] = [
  'PARTNER',
  'NEGOTIATING',
  'EXTERNAL',
];
